// extracted by mini-css-extract-plugin
export default {"image":"lX-z","loaded":"mX-z"};